export default "__VITE_ASSET__Dg56O3f$__"